import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '@/config/index.js'

import Home from '@/views/home/index.vue'
import Chat from '@/views/chat/index.vue'
import CustomerService from '@/views/customerService/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name:"Home",
    component: Home,
    redirect:"home",
    children:[
      {
        path:"/home",
        name:"Home",
        component: Home
      }
    ]
  },
  {
    path:'/customerService',
    name:'CustomerService',
    component: CustomerService,
  },
  {
    path:"/chat",
    name:'CustomerService',
    component: Chat
  }
]

const router = new VueRouter(
  {
    mode: 'hash',
    base: config.server,
    routes
  }
)

export default router
